import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EConsignmentSortField,
  IConsignment,
  PConsignmentFilter,
} from "src/core/consignment/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IConsignmentState {
  consignments: IConsignment[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IConsignmentState = {
  consignments: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "consignment/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "consignment/FETCH_SUCCEEDED";
const FETCH_FAILED = "consignment/FETCH_FAILED";
const POLLING_START_REQUESTED = "consignment/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "consignment/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IConsignment[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PConsignmentFilter;
    pagination: IPagination;
    sorts: ISort<EConsignmentSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IConsignmentState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IConsignmentState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.consignments = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
